import { Link } from 'react-router-dom';
import { routing } from '@/i18n/routing';
import { Helmet } from 'react-helmet-async';

/** Root-level 404 (React Router catch-all). */
export default function RootNotFound() {
  const defaultLocale = routing.defaultLocale;

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-bg-main text-charcoal relative overflow-hidden">
      <Helmet>
        <title>Page not found | Highlandgroup</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="This page could not be found." />
      </Helmet>
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23111111' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      <section className="relative z-10 w-full max-w-2xl mx-auto px-6 sm:px-8 py-16 sm:py-20 text-center">
        <div className="relative mb-8 sm:mb-10">
          <span
            className="block text-[10rem] sm:text-[14rem] font-bold leading-none tracking-tighter text-charcoal/10 select-none"
            aria-hidden
          >
            404
          </span>
        </div>

        <p className="inline-flex items-center gap-2 rounded-full border border-border-light bg-bg-soft px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-muted mb-6">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-red" />
          Page not found
        </p>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-charcoal mb-4">
          This page could not be found
        </h1>
        <p className="text-muted text-sm sm:text-base max-w-md mx-auto leading-relaxed mb-10">
          The link you followed may be broken, or the page may have been moved
          or removed. Return to the homepage to find your way.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={`/${defaultLocale}`}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-red px-6 py-3.5 text-sm font-semibold text-white shadow-lg hover:opacity-90 transition-all"
          >
            Back to home
          </Link>
        </div>
      </section>
    </main>
  );
}
